import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import format from '@/common/utilities/format';

export default {
    name: 'propertyNearbyHomeValues',
    components: {
        mvtCollapse,
    },
    props: {
        disableCollapse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        listings() {
            const items = this.dpp.nearbyHomeValues;
            if (!items || items.length < 3) return null;
            return items;
        },
        nearbyPropertyLabel() {
            const map = {
                SINGLE_FAMILY_HOUSE: 'single-family homes',
                CONDO: 'condo homes',
                MULTI_FAMILY: 'multi-family homes',
                LAND: 'lots and land',
                MOBILE: 'mobile homes',
            };
            return map[this.dpp.propertyType] || 'single-family homes';
        },
    },
    methods: {
        formatValue(val) {
            if (!val) return '—';
            return '$' + format.formatNumberByComma(val);
        },
        formatBedBath(beds, baths) {
            const b = beds > 0 ? beds : '—';
            const ba = baths > 0 ? baths : '—';
            return `${b}/${ba}`;
        },
        formatSqft(sqft) {
            if (!sqft) return '—';
            return format.formatNumberByComma(sqft);
        },
        formatDistance(dist) {
            if (dist === null || dist === undefined) return '—';
            const val = Number(dist);
            return String(parseFloat(val.toFixed(2)));
        },
    },
};
